import { IconButton } from 'material-ui';
import PhotoIcon from 'material-ui/svg-icons/editor/insert-photo';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import * as React from 'react';
import Dropzone, { DropzoneProps } from 'react-dropzone';
import './../ViewStyles/Dropzone.css';

interface IFIADropzoneProps extends DropzoneProps {
    file?: any
    onClear: () => void
    placeholder?: string
}

export default class FIADropzone extends React.Component<IFIADropzoneProps> {

    public render() {
        const { file, onClear, placeholder } = this.props;
        const props = this.getDropZoneProps();
        return (
            <Dropzone
                {...props}
                disableClick={!file ? false : true}
                className="dropzone"
            >
                {!file ?
                    <div className="dropzone-icon">
                        <PhotoIcon color="#ccc" />
                        <label>Загрузите изображение <br /> {placeholder ? placeholder : 'поста'}</label>
                    </div>
                    :
                    <div className="dropzone-image">
                        <img src={file.url() ? file.url() : file._source.file.preview} />
                        <IconButton className="dropzone-remove-image">
                            <CloseIcon
                                onClick={onClear}
                                color="#fff"
                            />
                        </IconButton>
                    </div>
                }
            </Dropzone>
        )
    }

    private getDropZoneProps() {
        let p: any = this.props;
        if (Object.isFrozen(this.props)) {
            p = Object['unfreeze'](p)
        }
        delete p['onClear']
        return p;
    }
} 


// WEBPACK FOOTER //
// ./src/app/abstract/Views/Dropzone.tsx